import i18next from '../../config/i18next';

i18next.addResources('es', 'LoginService', {
  // default success
  successModalButton: 'Entendido',
  successMailSentTitle: 'El correo fue enviado exitosamente',
  successMailSentBody:
    'Revisá tu casilla de email para continuar con el cambio de contraseña',
  successPasswordSentTitle: 'Contraseña reseteada con éxito',
  successPasswordSentBody: 'La contraseña se cambió exitosamente',
  // default info
  successInfoMailSentTitle: 'Tu contraseña debe actualizarse  ',
  successInfoMailSentBody:
    'Te enviaremos las instrucciones para actualizar tu contraseña, revisa tu casilla de email para continuar.',
  // default error
  errorGeneralTitle: 'Error de comunicación',
  errorGeneralBody: 'Vuelva a intentarlo más tarde.',
  errorModalButton: 'Entendido',
  errorCode20031: 'Error de comunicación',
  errorCode20031Body: 'Vuelva a intentarlo más tarde.',
  errorCodeXXXX: 'Error de comunicación',
  errorCodeXXXXbody:
    'La contraseña no se pudo guardar, vuelva a intentarlo más tarde.',
  // status 400
  errorCode20001: 'Datos incorrectos',
  errorCode20001Body:
    'Los datos ingresados son incorrectos, intente nuevamente.',
  errorCode20002: 'Datos incorrectos',
  errorCode20002Body:
    'Los datos ingresados son incorrectos, intente nuevamente.',
  errorCode20006: 'Datos incorrectos',
  errorCode20006Body:
    'Los datos ingresados son incorrectos, intente nuevamente.',
  errorCode20007: 'Datos incorrectos',
  errorCode20007Body: 'La contraseña no puede contener el nombre o apellido.',
  errorCode20008: 'Tu cuenta se encuentra inactiva',
  errorCode20008Body: 'Por favor, comunícate con mesa de ayuda.',
  errorCode20009: 'Datos incorrectos',
  errorCode20009Body:
    'Los datos ingresados son incorrectos, intente nuevamente.',
  errorCode20010: 'Datos incorrectos',
  errorCode20010Body:
    'Los datos ingresados son incorrectos, intente nuevamente.',
  errorCode20013: 'Error al enviar la información',
  errorCode20013Body:
    'Ya existe un rol con el nombre solicitado dentro del aplicativo solicitado.',
  errorCode20014: 'Datos incorrectos',
  errorCode20014Body:
    'Los datos ingresados son incorrectos, intente nuevamente.',
  errorCode20015: 'Error al enviar la información',
  errorCode20015Body:
    'Esta intentando asignar dos roles a la misma aplicación.',
  errorCode20017: 'Error al enviar la información',
  errorCode20017Body: 'No se encontró el tipo de teléfono solicitado.',
  errorCode20018: 'El token ha expirado',
  errorCode20018Body: 'Por favor, intente loguearse nuevamente.',
  errorCode20019: 'Usuario no permitido',
  errorCode20019Body: 'No posee permisos para operar en esta aplicación',
  errorCode20020: 'Error al enviar la información',
  errorCode20020Body: 'No se encontró el recurso solicitado.',
  errorCode20021: 'Error al enviar la información',
  errorCode20021Body: 'Esta intentado asociar dos acciones a un mismo recurso.',
  errorCode20022: 'Datos incorrectos',
  errorCode20022Body:
    'Los datos ingresados son incorrectos, intente nuevamente.',
  errorCode20024: 'Enlace inválido',
  errorCode20024Body: 'El enlace venció, intente nuevamente.',
  errorCode20025: 'Error al enviar la información',
  errorCode20025Body: 'El usuario debe tener asociado al menos un teléfono.',
  errorCode20026: 'Error al enviar la información',
  errorCode20026Body: 'El usuario debe estar asociado a al menos un rol.',
  errorCode20027: 'Error de comunicación',
  errorCode20027Body: 'Vuelva a intentarlo más tarde.',
  errorCode20029: 'Error al enviar la información',
  errorCode20029Body: 'Error al generar request body.',
  errorCode20030: 'Error al enviar la información',
  errorCode20030Body: 'El teléfono no pertenece al usuario.',
  errorCode20032: 'Datos incorrectos',
  errorCode20032Body:
    'La contraseña no puede ser igual a ninguna de las dos anteriores.',
  errorCode20033: 'Datos Incorrectos',
  errorCode20033Body: 'El rol asociado no se encuentra activo.',
  // status 401
  errorCode20023: 'Datos incorrectos',
  errorCode20023Body:
    'Los datos ingresados son incorrectos, intente nuevamente.',
  // status 403
  errorCode20003: 'Datos incorrectos',
  errorCode20003Body:
    'Los datos ingresados son incorrectos, intente nuevamente.',
  // status 404
  errorCode20004: 'Datos incorrectos',
  errorCode20004Body:
    'Los datos ingresados son incorrectos, intente nuevamente.',
  errorCode20011: 'Usuario no permitido',
  errorCode20011Body: 'No posee permisos para operar en esta aplicación.',
  errorCode20012: 'Usuario no permitido',
  errorCode20012Body: 'No posee permisos para operar en esta aplicación.',
  errorCode20016: 'Datos incorrectos',
  errorCode20016Body:
    'Los datos ingresados son incorrectos, intente nuevamente.',
  errorCode20028: 'Datos Incorrectos',
  errorCode20028Body:
    'Los datos ingresados son incorrectos, intente nuevamente.',
  // status 429
  errorCode20005: 'Error de comunicación',
  errorCode20005Body: 'Vuelva a intentarlo más tarde.',
});
